import React, { useEffect, useState, forwardRef } from "react";
import moment from "moment";
import { NumberFormat } from "../../Components/NumberFormat";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import { REACT_APP_BASE_URL } from "../../Constants";
import { useParams } from "react-router-dom";
import { uuid, wordWrap } from "../../Utils/Utils";
import ReactHtmlParser from "react-html-parser";
import { getConfigAll } from "../../Service/SalesService";
import { get } from "lodash";

const PrintSO = forwardRef((props, ref) => {
  const { getState, getInfo, login } = props;
  const pageStyle = " @page { size: A4 portrait; margin: 20;}";
  const [qrCode, setQrCode] = useState("");
  const [config, setConfig] = useState([]);
  const [noteBill, setNoteBill] = useState("");
  const [footerBill, setFooterBill] = useState("");
  const [notePay, setNotePay] = useState([]);
  const [footerPay, setFooterPay] = useState([]);
  const [totalQty, setTotalQty] = useState(0);
  const base_url = REACT_APP_BASE_URL;

  const { id_so } = useParams();

  useEffect(() => {
    let ord_number = getState.order_no ? getState.order_no : id_so ? id_so : "";
    let word = `${base_url}estatement/salesorder/${ord_number}`;
    setQrCode(
      "https://api.qrserver.com/v1/create-qr-code/?data=" +
      word +
      "&size=400x400&bgcolor=ffff"
    );
  }, []);

  useEffect(() => {
    const results = [
      getConfigAll({ perpage: 10 }).then(res => res.data),
    ];
    Promise.all(results).then(results => {
      const [_config] = results;

      setConfig(_config?.data)

      let nbill = _config?.data.find(item => item.config_name === "note_bill_statement")?.config_value;
      const cleanNoteBill = nbill ? nbill.replace(/^"(.*)"$/, '$1') : "";

      setNoteBill(cleanNoteBill)

      let fbill = _config?.data.find(item => item.config_name === "footer_bill_statement")?.config_value;
      const cleanFooterBill = fbill ? fbill.replace(/^"(.*)"$/, '$1') : "";
      setFooterBill(cleanFooterBill)

      let npay = _config?.data.find(item => item.config_name === "note_pay_statement")?.config_value;
      const cleanNotePay = npay ? npay.replace(/^"(.*)"$/, '$1') : "";
      setNotePay(cleanNotePay)

      let fpay = _config?.data.find(item => item.config_name === "footer_pay_statement")?.config_value;
      const cleanFooterPay = fpay ? fpay.replace(/^"(.*)"$/, '$1') : "";
      setFooterPay(cleanFooterPay)
    })

    const totalQty = getInfo.detail.reduce((sum, item) => sum + Number(item.qty), 0)
    setTotalQty(totalQty);
  }, []);

  const netDiscountLabelGenerator = (detail) => {
    let discount_label = `Disc ${detail.M_DISC_1}%`;
    if (detail.M_DISC_2_PRC) discount_label += ` + ${detail.M_DISC_2_PRC}%`;

    return discount_label;
  };

  const netDiscountCalculator = (detail) => {
    let discount = detail.total_bef_di * detail.qty * (detail.disc_prcnt / 100);
    discount = discount.toFixed(2);
    return NumberFormat(discount);
  };
  const netDiscountCalculatorOnly = (detail) => {
    let discount = detail.total_bef_di * detail.qty * (detail.disc_prcnt / 100);
    discount = discount.toFixed(2);
    return discount;
  };

  let totalMZF = getInfo.detail
    .map((item) => item.final_price)
    .reduce((prev, next) => prev + next, 0);

  let total = totalMZF - getInfo.deduction;

  let campaign_net_disc = getInfo.total_before_discount_with_free -
    Math.round(total) -
    getInfo.deduction;

  let total_before_tax =
    login?.u_m_pkp == "Y" ? Math.round(
      (getInfo.total_before_discount_with_free - campaign_net_disc - getInfo.deduction) -
      ((getInfo.total_before_discount_with_free - campaign_net_disc - getInfo.deduction) /
        (getState.ppn_selected / 100 + 1))
    )
      : total;

  // let total_before_tax = login?.u_m_pkp == "Y" ? Math.round(
  //   (getInfo.total_before_discount_with_free - getInfo.total_discount - getInfo.deduction) / getState.ppn_selected) : total;


  let headerBg = getInfo.payment_verified === true ? "#000000" : "#000000";
  let logoRight = getInfo.payment_verified === true ? "-white" : "-white";
  return (
    <div
      id="content"
      ref={ref}
      style={{
        color: "#000", backgroundColor: "#fff", minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        fontFamily: '"Segoe UI", sans-serif' // tambahkan ini
      }}
    >
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <div style={{
          width: "100%",
          backgroundColor: headerBg,
          paddingTop: "20px",
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <img
            src={"/logo-modena-putih.png"}
            style={{
              maxWidth: "175px",
              // width: "100%",
              width: "99.2%",
              height: "auto",
              display: "block"
            }}
            alt="Header Invoice"
          />
        </div>
        <div style={{
          width: "100%",
          position: "relative",
          paddingBottom: "7px",
          minHeight: "130px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center", // center horizontal
          justifyContent: "center"
        }}>
          <div
            style={{
              fontSize: 30,
              fontWeight: 620,
              paddingTop: "17px",
              textAlign: "center"
            }}
          >
            {getInfo.payment_verified === true
              ? "PAYMENT RECEIPT"
              : "BILL STATEMENT"}
          </div>
          <div
            style={{
              fontSize: 16,
              fontWeight: "normal",
              // paddingTop: "7px",
              color: "#3361F7",
              textAlign: "center"
            }}
          >
            {getState.order_no}
          </div>
          <div style={{ position: "absolute", top: "7px", right: "0px" }}>
            {/* <img src={qrCode} width={100} /> */}
          </div>
        </div>
        {
          getInfo.payment_verified === true
            ?
            <>
              <div className="container" style={{
                // display: "flex",
                // flexWrap: "wrap",
                paddingTop: "5px",
                paddingBottom: "5px",
                // width: "100%",
                borderTop: "1px solid #CCCCCC",
                borderBottom: "1px solid #CCCCCC",
              }}>
                <div className="row">
                  <div className="col mt-4">
                    <p className="text-uppercase font-weight-bold" style={{ fontSize: "16px" }}>Payment Details</p>
                    <div className="row justify-content-start" style={{ fontSize: "16px" }}>
                      <div className="col-4">
                        Store Issued
                      </div>
                      <div className="col-6">
                        :{" "} <span className="font-weight-normal">
                          {getInfo.user_information?.BPLFrName || ""}
                        </span>
                      </div>
                    </div>
                    <div className="row justify-content-start" style={{ fontSize: "16px" }}>
                      <div className="col-4">

                      </div>
                      <div className="col-6">
                        <span className="font-weight-normal pl-2">
                          {getInfo.legal?.legal_name || ""}
                        </span>
                      </div>
                    </div>
                    <div className="row justify-content-start" style={{ fontSize: "16px" }}>
                      <div className="col-4">
                        Date
                      </div>
                      <div className="col-6">
                        :{" "} <span className="font-weight-normal">{moment(getInfo.created_date).format("DD MMMM YYYY")}</span>
                      </div>
                    </div>
                    <div className="row justify-content-start" style={{ fontSize: "16px" }}>
                      <div className="col-4">
                        Method
                      </div>
                      <div className="col-6">
                        :{" "} <span className="font-weight-normal">
                          {
                            getState.listPayment && getState.listPayment.length > 0 && getState.listPayment[0]?.payment_type === "IPG" ? "PG Transfer" : "Card Payment"
                          }</span>
                      </div>
                    </div>
                    <div className="row justify-content-start" style={{ fontSize: "16px" }}>
                      <div className="col-4">
                        Status
                      </div>
                      <div className="col-4">
                        :{" "} <span className="font-weight-bold">{getInfo.payment_verified === true ? "PAID" : "UNPAID"}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col rounded" style={{
                    width: "50%",
                    backgroundColor: "#F1F5F9",
                    padding: "15px",
                    // paddingTop: "10px",
                    border: "1px solid #F1F5F9",
                    overflow: "hidden", // Pastikan overflow diatur jika ada konten yang melampaui
                    margin: 12
                  }}>
                    <div className="col-12">
                      <p className="text-uppercase text-wrap font-weight-bold" style={{ fontSize: "16px" }}>
                        Customer Details
                      </p>
                      <div className="row justify-content-start" style={{ fontSize: "16px" }}>
                        <div className="col-3">
                          Name
                        </div>
                        <div className="col-9">
                          :{" "} <span className="text-wrap font-weight-normal">{getInfo.nama_customer}</span>
                        </div>
                      </div>
                      <div className="row justify-content-start" style={{ fontSize: "16px" }}>
                        <div className="col-3">
                          NPWP
                        </div>
                        <div className="col-9">
                          :{" "} <span className="text-wrap font-weight-normal">{getInfo.npwp ?? "-"}</span>
                        </div>
                      </div>
                      <div className="row justify-content-start" style={{ fontSize: "16px" }}>
                        <div className="col-3">
                          Email
                        </div>
                        <div className="col-9">
                          :{" "} <span className="text-wrap font-weight-normal">{getInfo.email}</span>
                        </div>
                      </div>
                      <div className="row justify-content-start" style={{ fontSize: "16px" }}>
                        <div className="col-3">
                          Phone
                        </div>
                        <div className="col-9">
                          :{" "} <span className="text-wrap font-weight-normal">{getInfo.phone}</span>
                        </div>
                      </div>
                      <div className="row justify-content-start" style={{ fontSize: "16px" }}>
                        <div className="col-3">
                          Add
                        </div>
                        <div className="col-9">
                          :{" "} <span className="text-wrap font-weight-normal">{getInfo.address}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
            :
            <>
              <div className="container" style={{
                // display: "flex",
                // flexWrap: "wrap",
                paddingTop: "5px",
                paddingBottom: "5px",
                // width: "100%",
                borderTop: "1px solid #CCCCCC",
                borderBottom: "1px solid #CCCCCC",
              }}>
                <div className="row">
                  <div className="col">
                    <p className="font-weight-bolder" style={{ fontSize: "16px" }}>From</p>
                    <span className="text-uppercase font-weight-bold" style={{ fontSize: "16px" }}>
                      {login?.BPLFrName ||
                        login?.BPLName ||
                        getInfo?.bplfrname ||
                        getInfo.bpl_name}
                    </span>
                    <br />
                    <span style={{ fontSize: "16px" }}>
                      {getInfo.legal.legal_name && (
                        <span className="text-uppercase font-weight-bold">
                          {" "}
                          ({getInfo.legal.legal_name})<br />
                        </span>
                      )}
                    </span>
                    <span className="text-wrap" style={{ fontSize: "16px", wordBreak: "break-word" }}>
                      {login?.Address || getInfo.mhc_address}
                    </span>
                    <br />
                    {/* {login?.phone && <span className="font-weight-normal" style={{ fontSize: "16px" }}>Telp {login?.phone}</span>}
                      <br /> */}
                    <div className="row justify-content-start">
                      <div className="col-4">
                        Purchase Date
                      </div>
                      <div className="col-4">
                        :{" "} <span className="font-weight-bolder">{moment(getInfo.created_date).format("DD MMMM YYYY")}</span>
                      </div>
                    </div>
                    <div className="row justify-content-start">
                      <div className="col-4">
                        Delivery Date
                      </div>
                      <div className="col-4">
                        :{" "} <span className="font-weight-bolder">{moment(getInfo.delivery_date).format("DD MMMM YYYY")}</span>
                      </div>
                    </div>
                    <div className="row justify-content-start">
                      <div className="col-4">
                        Sales
                      </div>
                      <div className="col-4">
                        :{" "} <span className="font-weight-bolder">{getState.created_by_name}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col rounded" style={{
                    width: "50%",
                    backgroundColor: "#F1F5F9",
                    padding: "15px",
                    margin: 12,
                    // paddingTop: "10px",
                    border: "1px solid #F1F5F9",
                    overflow: "hidden", // Pastikan overflow diatur jika ada konten yang melampaui
                  }}>
                    <p className="font-weight-bolder" style={{ fontSize: "16px" }}>
                      Billed To
                    </p>
                    <span style={{ fontSize: "16px" }}>
                      {getInfo.nama_customer}
                      <br />
                      {getInfo.address}
                      <br />
                      <br />
                      <span className="font-weight-bolder">Contact Person</span>
                      <br />
                      {getInfo.nama_customer}
                      <br />
                      Phone. {getInfo.phone}
                      <br />
                      Email. {getInfo.email}
                    </span>
                  </div>
                </div>
              </div>
            </>
        }
      </div>

      <style>{pageStyle}</style>

      <div className="row" style={{ margin: 10, padding: 10 }}>
        <span className="font-weight-bolder" style={{ paddingBottom: "13px" }}>
          Detail Order
        </span>
        {/* <h5 className="font-weight-bold mb-3">Detail Order</h5> */}
        <div className="table-responsive">
          <table className="table-light w-100" border={0} > {/*ini kalo ada tulisan table diclassname jadi table kek di yg laen*/}
            <thead className="thead-light">
              <tr style={{ height: "35px", borderBottom: "1px solid #d2d5d9", fontSize: 14, textAlign: "center" }}>
                <th style={{ color: "#1A317C", backgroundColor: "#F1F5F9", padding: "8px 16px" }}>No</th>
                <th
                  style={{
                    color: "#1A317C",
                    backgroundColor: "#F1F5F9",
                    width: "28%", // atur lebar kolom item
                    minWidth: 180,
                    maxWidth: 300,
                    wordBreak: "break-word",
                    padding: "8px 16px"
                  }}
                >
                  Name
                </th>
                <th style={{ color: "#1A317C", backgroundColor: "#F1F5F9", padding: "8px 16px" }}>
                  Qty
                </th>
                <th
                  style={{
                    textAlign: "center",
                    color: "#1A317C",
                    backgroundColor: "#F1F5F9",
                    padding: "8px 16px"
                  }}
                >
                  Price/Unit
                </th>
                {/* <th
                style={{
                  textAlign: "right",
                  color: "#1A317C",
                  backgroundColor: "#F1F5F9",
                }}
              >
                PPN
              </th> */}
                {/* <th>PPH</th> */}
                <th
                  style={{
                    textAlign: "center",
                    color: "#1A317C",
                    backgroundColor: "#F1F5F9",
                    padding: "8px 16px",
                    minWidth: 120,
                  }}
                >
                  Total Before Discount
                </th>
                <th style={{
                  textAlign: "center",
                  color: "#1A317C",
                  backgroundColor: "#F1F5F9",
                  padding: "8px 16px",
                  minWidth: 120,
                }}
                >
                  Promo
                </th>
                <th style={{
                  textAlign: "center",
                  color: "#1A317C",
                  backgroundColor: "#F1F5F9",
                  padding: "8px 16px"
                }}
                >
                  Total Discount (Rp)
                </th>
                <th
                  style={{
                    textAlign: "center",
                    color: "#1A317C",
                    backgroundColor: "#F1F5F9",
                    padding: "8px 16px"
                  }}
                >
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {getInfo.detail.map((row, index) => (
                <>
                  <tr
                    style={{
                      borderBottom: "1px solid #d2d5d9",
                      fontSize: 14
                    }}
                    key={`tr-` + index}
                  >
                    <td style={{ borderTop: "none", color: "#000", padding: "8px 12px" }}>
                      {index + 1}
                    </td>
                    <td
                      style={{
                        borderTop: "none",
                        color: "#000",
                        wordBreak: "break-word",
                        maxWidth: 300,
                        whiteSpace: "pre-line",
                        overflowWrap: "break-word",
                        padding: "8px 12px"
                      }}
                    >
                      {row.itemname}
                    </td>
                    <td style={{ borderTop: "none", textAlign: "center", color: "#000", padding: "8px 12px" }}>
                      {row.qty}
                    </td>
                    <td
                      style={{
                        borderTop: "none",
                        textAlign: "right",
                        color: "#000",
                        whiteSpace: "nowrap", // tetap satu baris
                        minWidth: 120, // agar satu baris
                        padding: "8px 12px"
                      }}
                    >
                      {"Rp "}{NumberFormat(row.price)}
                    </td>
                    <td
                      style={{
                        borderTop: "none",
                        // borderBottom: "1px solid #d2d5d9",
                        borderLeft: "none",
                        borderRight: "none",
                        // borderColor: "GrayText",
                        textAlign: "right",
                        color: "#000",
                        whiteSpace: "nowrap", // agar satu baris
                        padding: "8px 12px",
                        minWidth: 120,
                      }}
                    >
                      {
                        !row.paketid &&
                        <>
                          {/* {"Rp "} {netDiscountCalculator(row)} */}
                          {NumberFormat(Math.round(row.price * row.qty))}
                        </>
                      }
                      {
                        row.paketid && row.free == 0 &&
                        <>
                          {/* {"Rp "} {netDiscountCalculator(row)} */}
                          {NumberFormat(Math.round(row.price * row.qty))}
                        </>
                      }
                      {
                        row.paketid && row.free == 1 &&
                        <>{NumberFormat(Math.round(row.price * row.qty))}</>
                      }
                    </td>
                    <td
                      style={{
                        borderTop: "none",
                        // borderBottom: "1px solid #d2d5d9",
                        borderLeft: "none",
                        borderRight: "none",
                        textAlign: "center",
                        color: "#000",
                        padding: "8px 12px"
                      }}
                    >
                      {
                        !row.paketid &&
                        <>
                          {netDiscountLabelGenerator(row)}
                        </>
                      }
                      {
                        row.paketid && row.free == 0 &&
                        <>
                          {netDiscountLabelGenerator(row)}
                        </>
                      }
                      {
                        row.paketid && row.free == 1 &&
                        <>Disc 100%</>
                      }
                    </td>
                    <td
                      style={{
                        borderTop: "none",
                        textAlign: "right",
                        color: "#000",
                        whiteSpace: "nowrap",
                        minWidth: 120,
                        padding: "8px 12px"
                      }}
                    >
                      {"Rp "}{netDiscountCalculator(row)}
                    </td>
                    <td
                      style={{
                        borderTop: "none",
                        textAlign: "right",
                        color: "#000",
                        whiteSpace: "nowrap",
                        minWidth: 120,
                        padding: "8px 12px"
                      }}
                    >
                      {
                        !row.paketid &&
                        <>
                          {"Rp "}
                          {NumberFormat(
                            Math.round(
                              row.price * row.qty - row.amount_discount
                            )
                          )}
                        </>
                      }
                      {
                        row.paketid && row.free == 0 &&
                        <>
                          {"Rp "}{NumberFormat((row.qty * row.price) - netDiscountCalculatorOnly(row))}
                        </>
                      }
                      {
                        row.paketid && row.free == 1 &&
                        <>Rp 0</>
                      }
                    </td>
                  </tr>
                  {/*footer*/}
                  {/* <tr
                    style={{
                      borderBottom: "1px solid #d2d5d9",
                      fontSize: 14
                    }}
                  >
                    <td style={{ borderTop: "none", color: "#000", padding: "8px 12px" }}>
                      {" "}
                    </td>
                    <td
                      style={{
                        borderTop: "none",
                        color: "#000",
                        wordBreak: "break-word",
                        maxWidth: 320,
                        whiteSpace: "pre-line",
                        overflowWrap: "break-word",
                        padding: "8px 12px"
                      }}
                    >
                      {" "}
                    </td>
                    <td style={{ borderTop: "none", textAlign: "center", color: "#000", padding: "8px 12px" }}>
                      {" "}
                    </td>
                    <td
                      style={{
                        borderTop: "none",
                        textAlign: "right",
                        color: "#000",
                        whiteSpace: "nowrap", // tetap satu baris
                        minWidth: 120, // agar satu baris
                        padding: "8px 12px"
                      }}
                    >
                      {" "}
                    </td>
                    <td
                      style={{
                        borderTop: "none",
                        borderLeft: "none",
                        borderRight: "none",
                        textAlign: "right",
                        color: "#000",
                        whiteSpace: "nowrap", // agar satu baris
                        padding: "8px 12px"
                      }}
                    >
                      {" "}
                    </td>
                    <td
                      style={{
                        borderTop: "none",
                        // borderBottom: "1px solid #d2d5d9",
                        borderLeft: "none",
                        borderRight: "none",
                        textAlign: "center",
                        color: "#000",
                        padding: "8px 12px"
                      }}
                    >
                      {" "}
                    </td>
                    <td
                      style={{
                        borderTop: "none",
                        textAlign: "right",
                        color: "#000",
                        whiteSpace: "nowrap",
                        minWidth: 120,
                        padding: "8px 12px"
                      }}
                    >
                      Total Price{` (${totalQty} Item)`}
                    </td>
                    <td
                      style={{
                        borderTop: "none",
                        textAlign: "right",
                        color: "#000",
                        whiteSpace: "nowrap",
                        minWidth: 120,
                        padding: "8px 12px"
                      }}
                    >
                      {"Rp "}{NumberFormat(Math.round(getInfo.grand_total + getInfo.deduction))}
                    </td>
                  </tr> */}
                  {
                    getInfo?.deduction > 0 &&
                    <tr
                      style={{
                        borderBottom: "1px solid #d2d5d9",
                        fontSize: 14
                      }}
                    >
                      <td style={{ borderTop: "none", color: "#000", padding: "8px 12px" }}>
                        {" "}
                      </td>
                      <td
                        style={{
                          borderTop: "none",
                          color: "#000",
                          wordBreak: "break-word",
                          maxWidth: 320,
                          whiteSpace: "pre-line",
                          overflowWrap: "break-word",
                          padding: "8px 12px"
                        }}
                      >
                        {" "}
                      </td>
                      <td style={{ borderTop: "none", textAlign: "center", color: "#000", padding: "8px 12px" }}>
                        {" "}
                      </td>
                      <td
                        style={{
                          borderTop: "none",
                          textAlign: "right",
                          color: "#000",
                          whiteSpace: "nowrap", // tetap satu baris
                          minWidth: 120, // agar satu baris
                          padding: "8px 12px"
                        }}
                      >
                        {" "}
                      </td>
                      <td
                        style={{
                          borderTop: "none",
                          borderLeft: "none",
                          borderRight: "none",
                          textAlign: "right",
                          color: "#000",
                          whiteSpace: "nowrap", // agar satu baris
                          padding: "8px 12px"
                        }}
                      >
                        {" "}
                      </td>
                      <td
                        style={{
                          borderTop: "none",
                          // borderBottom: "1px solid #d2d5d9",
                          borderLeft: "none",
                          borderRight: "none",
                          textAlign: "center",
                          color: "#000",
                          padding: "8px 12px"
                        }}
                      >
                        {" "}
                      </td>
                      <td
                        style={{
                          borderTop: "none",
                          textAlign: "right",
                          color: "#000",
                          whiteSpace: "nowrap",
                          minWidth: 120,
                          padding: "8px 12px"
                        }}
                      >
                        Additional Discount
                      </td>
                      <td
                        style={{
                          borderTop: "none",
                          textAlign: "right",
                          color: "#000",
                          whiteSpace: "nowrap",
                          minWidth: 120,
                          padding: "8px 12px"
                        }}
                      >
                        {"Rp "}{NumberFormat(getInfo.deduction)}
                      </td>
                    </tr>
                  }

                </>
              ))}
              <tr
                style={{
                  // borderBottom: "1px solid #d2d5d9",
                  alignItems: "top",
                  fontSize: 14,
                  lineHeight: "10px"
                }}
              >

                <td
                  colSpan="7"
                  style={{
                    borderTop: "none",
                    textAlign: "right",
                    color: "#000",
                    whiteSpace: "nowrap",
                    minWidth: 120,
                    padding: "20px 10px 20px",
                  }}
                >
                  Total Payment
                  <div className="text-dark font-weight-lighter">{"."}</div>
                </td>
                <td
                  style={{
                    borderTop: "none",
                    textAlign: "right",
                    color: "#000",
                    whiteSpace: "nowrap",
                    minWidth: 120,
                    paddingRight: "10px",
                    paddingTop: "0px"
                  }}
                >
                  {"Rp "}{NumberFormat(Math.round(getInfo.grand_total))}
                </td>
              </tr>
              <tr
                style={{
                  borderBottom: "1px solid #d2d5d9",
                  fontSize: 14
                }}
              >
                <td colSpan="8" style={{ borderTop: "none", textAlign: "right", color: "#000", padding: "8px 12px" }}>
                  {!getInfo.dealer_non_pkp?.some(item => item.code_name === getInfo.user_information?.BPLName) && (
                    <div className="text-dark font-weight-lighter">*Total price includes VAT</div>
                  )}
                </td>
              </tr>
            </tbody>
            <tfoot>

            </tfoot>
          </table>
        </div>
      </div>
      <div style={{ paddingRight: "20px", paddingLeft: "20px", marginLeft: 20, paddingBottom: "0px", textAlign: "justify", border: "none" }}>
        <p className="text-capitalize font-weight-normal" style={{ fontSize: 14, color: "black" }}>Terbilang : {" "} {angkaTerbilang(Math.round(getInfo.grand_total))}</p>
      </div>
      <div style={{
        paddingTop: "20px",
        paddingRight: "20px",
        paddingLeft: "20px",
        paddingBottom: "0px",
        backgroundColor: "#F9FBFF",
        marginTop: "0px",
        textAlign: "justify",
        fontSize: 12,
        color: "#000",
        border: "none",
        maxWidth: "960px", // atau sesuai keinginanmu
        width: "100%",
        marginLeft: "auto",
        marginRight: "auto"
      }}>
        {getInfo.payment_verified === true
          ? ReactHtmlParser(notePay)
          : ReactHtmlParser(noteBill)}
      </div>

      <div style={{
        paddingTop: "0px",
        marginTop: "0px",
        paddingBottom: "20px",
        paddingRight: "20px",
        paddingLeft: "20px",
        backgroundColor: "#F9FBFF",
        textAlign: "justify",
        fontSize: 12,
        color: "#000",
        // borderTop: "2px solid #CCCCCC",
        // borderTop: "2px dashed #CCCCCC",
        maxWidth: "960px", // batas kanan kiri
        width: "100%",
        marginLeft: "auto",
        marginRight: "auto"
      }}>
        {getInfo.payment_verified === true
          ?
          <div className="mt-2">
            {ReactHtmlParser(footerPay)}
          </div>
          : <div className="mt-2">
            {ReactHtmlParser(footerBill)}
          </div>
        }
      </div>
      {/* <div style={{ marginTop: "auto" }}></div> */}
    </div>
  );
});

export default PrintSO;